import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { api, saveToken, getToken } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  if (getToken()) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      saveToken(data.token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-bone flex" data-testid="admin-login-page">
      <div className="hidden md:flex md:w-1/2 relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjByZXNpZGVudGlhbCUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzg0MzYyMTEyfDA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/45" />
        <div className="relative z-10 p-12 flex flex-col justify-between text-bone w-full">
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] opacity-70">Muse n Aura · Studio</p>
          </div>
          <div>
            <h2 className="font-serif text-5xl leading-tight">The atelier,<br /><span className="italic text-clayLight">behind the veil.</span></h2>
            <p className="mt-6 opacity-75 max-w-sm">A private workspace to compose new work, curate archive, and read incoming notes.</p>
          </div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <p className="text-[11px] uppercase tracking-[0.3em] text-muteInk">— Studio Access</p>
          <h1 className="font-serif text-4xl md:text-5xl leading-[1.02] tracking-tight mt-4 text-ink">Sign in.</h1>
          <div className="mt-10 space-y-6">
            <div>
              <label className="block text-[10px] uppercase tracking-[0.3em] text-muteInk mb-2">Email</label>
              <input
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                data-testid="login-email"
                className="w-full bg-transparent border-b border-borderWarm focus:border-ink outline-none py-3 text-lg text-ink"
              />
            </div>
            <div>
              <label className="block text-[10px] uppercase tracking-[0.3em] text-muteInk mb-2">Password</label>
              <input
                type="password"
                required
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                data-testid="login-password"
                className="w-full bg-transparent border-b border-borderWarm focus:border-ink outline-none py-3 text-lg text-ink"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full border border-ink py-3.5 text-[12px] uppercase tracking-[0.22em] hover:bg-ink hover:text-bone transition-colors duration-300 disabled:opacity-50"
            >
              {loading ? "Signing in…" : "Enter Studio"}
            </button>
          </div>
        </form>
      </div>
    </main>
  );
}
